import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "portal-page__inner consult-board-detail__shell" }
const _hoisted_2 = { class: "portal-page__head" }
const _hoisted_3 = {
  key: 0,
  class: "portal-page__eyebrow"
}
const _hoisted_4 = { class: "portal-page__title" }
const _hoisted_5 = {
  key: 0,
  class: "consult-board-detail__status"
}
const _hoisted_6 = {
  key: 1,
  class: "consult-board-detail__status consult-board-detail__status--error"
}
const _hoisted_7 = {
  key: 2,
  class: "consult-board-detail__panel"
}
const _hoisted_8 = { class: "consult-board-detail__head" }
const _hoisted_9 = { class: "consult-board-detail__head-bar" }
const _hoisted_10 = { class: "consult-board-detail__date" }
const _hoisted_11 = { class: "consult-board-detail__post-title" }
const _hoisted_12 = { class: "consult-board-detail__meta-strip" }
const _hoisted_13 = { class: "consult-board-detail__info" }
const _hoisted_14 = { class: "consult-board-detail__block" }
const _hoisted_15 = { class: "consult-board-detail__block-title" }
const _hoisted_16 = { class: "consult-board-detail__content-text" }
const _hoisted_17 = {
  key: 0,
  class: "consult-board-detail__block"
}
const _hoisted_18 = { class: "consult-board-detail__attach" }
const _hoisted_19 = { class: "consult-board-detail__attach-info" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 1,
  class: "consult-board-detail__block consult-board-detail__reply-block"
}
const _hoisted_22 = { class: "consult-board-detail__block-title" }
const _hoisted_23 = { class: "consult-board-detail__reply-head" }
const _hoisted_24 = { class: "consult-board-detail__reply-text" }
const _hoisted_25 = {
  key: 0,
  class: "consult-board-detail__attach consult-board-detail__attach--reply"
}
const _hoisted_26 = { class: "consult-board-detail__attach-info" }
const _hoisted_27 = ["disabled", "onClick"]
const _hoisted_28 = {
  key: 2,
  class: "consult-board-detail__block consult-board-detail__reply-wait"
}
const _hoisted_29 = { class: "consult-board-detail__block-title" }
const _hoisted_30 = { class: "consult-board-detail__edit-note" }
const _hoisted_31 = {
  key: 3,
  class: "consult-board-detail__error"
}
const _hoisted_32 = { class: "consult-board-detail__foot" }
const _hoisted_33 = ["disabled"]

import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import {
  deleteConsultPost,
  downloadConsultExcel,
  downloadConsultResponseExcel,
  fetchConsultPostMeta,
  verifyConsultPost,
} from '@/api/consultBoard'
import { MALL_MY_CONSULTS_PATH } from '@/constants/mallMy'
import type {
  ConsultBoardPostDetail,
  ConsultBoardPostMeta,
  ConsultBoardResponseItem,
} from '@/types/consultBoard'


export default /*@__PURE__*/_defineComponent({
  __name: 'ConsultBoardDetailPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const postId = Number(route.params.id)
const isMall = computed(() => route.meta.layout === 'mall')
const listPath = computed(() => (isMall.value ? MALL_MY_CONSULTS_PATH : '/consult-board'))
const loading = ref(true)
const loadError = ref('')
const meta = ref<ConsultBoardPostMeta | null>(null)

const verifyError = ref('')
const accessToken = ref('')
const post = ref<ConsultBoardPostDetail | null>(null)
const responses = ref<ConsultBoardResponseItem[]>([])
const downloading = ref(false)
const downloadingResponseId = ref<number | null>(null)
const deleting = ref(false)

const loadMeta = async () => {
  loadError.value = ''
  try {
    meta.value = await fetchConsultPostMeta(postId)
  } catch (e) {
    loadError.value = e instanceof Error ? e.message : '글 정보를 불러오지 못했습니다.'
  }
}

const applyVerified = (result: { accessToken: string; post: ConsultBoardPostDetail; responses: ConsultBoardResponseItem[] }) => {
  accessToken.value = result.accessToken
  post.value = result.post
  responses.value = result.responses
}

const tryMemberOpen = async () => {
  const result = await verifyConsultPost(postId)
  applyVerified(result)
}

const onDownload = async () => {
  if (!accessToken.value) return
  downloading.value = true
  try {
    await downloadConsultExcel(postId, accessToken.value)
  } catch (e) {
    verifyError.value = e instanceof Error ? e.message : '다운로드에 실패했습니다.'
  } finally {
    downloading.value = false
  }
}

const onResponseExcelDownload = async (response: ConsultBoardResponseItem) => {
  if (!accessToken.value) return
  downloadingResponseId.value = response.id
  try {
    await downloadConsultResponseExcel(
      postId,
      response.id,
      accessToken.value,
      response.excelName || `consult-response-${response.id}.xlsx`,
    )
  } catch (e) {
    verifyError.value = e instanceof Error ? e.message : '다운로드에 실패했습니다.'
  } finally {
    downloadingResponseId.value = null
  }
}

const onDelete = async () => {
  const targetLabel = isMall.value ? '문의' : '상담 신청'
  if (!window.confirm(`${targetLabel}을 삭제할까요? 삭제 후에는 복구할 수 없습니다.`)) {
    return
  }

  deleting.value = true
  verifyError.value = ''
  try {
    await deleteConsultPost(postId)
    router.push(listPath.value)
  } catch (e) {
    verifyError.value = e instanceof Error ? e.message : '글 삭제에 실패했습니다.'
  } finally {
    deleting.value = false
  }
}

const formatDate = (value: string) => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleString('ko-KR')
}

onMounted(async () => {
  if (!postId) {
    loadError.value = '잘못된 게시글 번호입니다.'
    loading.value = false
    return
  }
  /* 로그인 회원 본인 글만 연다 */
  try {
    await Promise.all([loadMeta(), tryMemberOpen()])
  } catch (e) {
    loadError.value = e instanceof Error ? e.message : '글을 열 수 없습니다.'
  }
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["portal-page consult-board-detail", { 'consult-board-detail--mall': isMall.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        (!isMall.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "상담"))
          : _createCommentVNode("", true),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(isMall.value ? '문의 상세' : '상담 신청 상세'), 1)
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "불러오는 중..."))
        : (loadError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(loadError.value) + " ", 1),
              _createVNode(_component_router_link, {
                to: listPath.value,
                class: "btn-secondary consult-board-detail__back-list"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isMall.value ? '문의 내역' : '상담 신청 내역'), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : (post.value)
            ? (_openBlock(), _createElementBlock("article", _hoisted_7, [
                _createElementVNode("header", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["consult-board-detail__status-badge", {
                  'consult-board-detail__status-badge--done': post.value.status === 'DONE',
                  'consult-board-detail__status-badge--wait': post.value.status !== 'DONE',
                }])
                    }, _toDisplayString(post.value.status === 'DONE' ? '답변완료' : '답변대기'), 3),
                    _createElementVNode("time", _hoisted_10, _toDisplayString(formatDate(post.value.createdAt)), 1)
                  ]),
                  _createElementVNode("h2", _hoisted_11, _toDisplayString(post.value.title), 1),
                  _createElementVNode("dl", _hoisted_12, [
                    _createElementVNode("div", null, [
                      _cache[0] || (_cache[0] = _createElementVNode("dt", null, "작성자 ID", -1)),
                      _createElementVNode("dd", null, _toDisplayString(post.value.authorId), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[1] || (_cache[1] = _createElementVNode("dt", null, "글 번호", -1)),
                      _createElementVNode("dd", null, _toDisplayString(post.value.id), 1)
                    ])
                  ])
                ]),
                _createElementVNode("dl", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _cache[2] || (_cache[2] = _createElementVNode("dt", null, "기관명", -1)),
                    _createElementVNode("dd", null, _toDisplayString(post.value.orgName), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[3] || (_cache[3] = _createElementVNode("dt", null, "기관 기호", -1)),
                    _createElementVNode("dd", null, _toDisplayString(post.value.orgCode || '—'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[4] || (_cache[4] = _createElementVNode("dt", null, "연락처", -1)),
                    _createElementVNode("dd", null, _toDisplayString(post.value.contactPhone), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[5] || (_cache[5] = _createElementVNode("dt", null, "이메일", -1)),
                    _createElementVNode("dd", null, _toDisplayString(post.value.email || '—'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("dt", null, "관련 주문", -1)),
                    _createElementVNode("dd", null, [
                      (post.value.orderCode)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/mall/orders/${encodeURIComponent(post.value.orderCode)}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(post.value.orderCode), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(isMall.value ? '주문번호 없음' : '기관 운영 상담'), 1)
                          ], 64))
                    ])
                  ])
                ]),
                _createElementVNode("section", _hoisted_14, [
                  _createElementVNode("h3", _hoisted_15, _toDisplayString(isMall.value ? '문의 내용' : '상담 내용'), 1),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(post.value.content), 1)
                ]),
                (post.value.hasExcel)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                      _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "consult-board-detail__block-title" }, "첨부 파일", -1)),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(AppIcon, {
                            icon: "mdi-file-excel-box",
                            size: 22
                          }),
                          _createElementVNode("span", null, _toDisplayString(post.value.excelName), 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-secondary consult-board-detail__attach-btn",
                          disabled: downloading.value,
                          onClick: onDownload
                        }, _toDisplayString(downloading.value ? '다운로드 중...' : 'Excel 다운로드'), 9, _hoisted_20)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (responses.value.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                      _createElementVNode("h3", _hoisted_22, _toDisplayString(isMall.value ? '문의 답변' : '상담 답변'), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(responses.value, (response) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: response.id,
                          class: "consult-board-detail__reply-card"
                        }, [
                          _createElementVNode("header", _hoisted_23, [
                            _createElementVNode("strong", null, _toDisplayString(response.byName), 1),
                            _createElementVNode("time", null, _toDisplayString(formatDate(response.createdAt)), 1)
                          ]),
                          _createElementVNode("p", _hoisted_24, _toDisplayString(response.content), 1),
                          (response.hasExcel)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createVNode(AppIcon, {
                                    icon: "mdi-file-excel-box",
                                    size: 20
                                  }),
                                  _createElementVNode("span", null, _toDisplayString(response.excelName), 1)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn-secondary consult-board-detail__attach-btn",
                                  disabled: downloadingResponseId.value === response.id,
                                  onClick: ($event: any) => (onResponseExcelDownload(response))
                                }, _toDisplayString(downloadingResponseId.value === response.id ? '다운로드 중...' : 'Excel 다운로드'), 9, _hoisted_27)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : (post.value.status === 'WAIT')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_28, [
                        _createElementVNode("h3", _hoisted_29, _toDisplayString(isMall.value ? '문의 답변' : '상담 답변'), 1),
                        _cache[8] || (_cache[8] = _createElementVNode("p", null, "답변을 준비 중입니다. 잠시 후 다시 확인해 주세요.", -1))
                      ]))
                    : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_30, _toDisplayString(isMall.value ? '문의는 수정할 수 없습니다. 내용 변경이 필요하면 삭제 후 다시 작성해 주세요.' : '상담 신청은 수정할 수 없습니다. 내용 변경이 필요하면 삭제 후 다시 신청해 주세요.'), 1),
                (verifyError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(verifyError.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("footer", _hoisted_32, [
                  _createVNode(_component_router_link, {
                    to: listPath.value,
                    class: "btn-secondary consult-board-detail__back-list"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(isMall.value ? '문의 내역' : '상담 신청 내역'), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "consult-board-detail__delete",
                    disabled: deleting.value,
                    onClick: onDelete
                  }, _toDisplayString(deleting.value ? '삭제 중...' : isMall.value ? '문의 삭제' : '상담 신청 삭제'), 9, _hoisted_33)
                ])
              ]))
            : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})